import React from 'react';

interface DocumentCategorySelectorProps {
  documentCategory: 'employee' | 'car';
  setDocumentCategory: (category: 'employee' | 'car') => void;
}

const DocumentCategorySelector: React.FC<DocumentCategorySelectorProps> = ({
  documentCategory,
  setDocumentCategory,
}) => {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-3">
        Document For (نوع الكيان)
      </label>
      <div className="flex gap-4">
        <label className={`flex-1 flex items-center justify-center p-4 border-2 rounded-lg cursor-pointer transition-all ${
          documentCategory === 'employee' 
            ? 'border-primary-500 bg-primary-50 text-primary-700' 
            : 'border-gray-300 bg-white hover:border-gray-400'
        }`}>
          <input
            type="radio"
            value="employee"
            checked={documentCategory === 'employee'}
            onChange={() => setDocumentCategory('employee')}
            className="sr-only"
          />
          <div className="flex flex-col items-center">
            <svg className="w-8 h-8 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span className="font-medium">Employee (موظف)</span>
            <span className="text-xs text-gray-500 mt-1">Crew certificates & documents</span>
          </div>
        </label>
        <label className={`flex-1 flex items-center justify-center p-4 border-2 rounded-lg cursor-pointer transition-all ${
          documentCategory === 'car' 
            ? 'border-primary-500 bg-primary-50 text-primary-700' 
            : 'border-gray-300 bg-white hover:border-gray-400'
        }`}>
          <input
            type="radio"
            value="car"
            checked={documentCategory === 'car'}
            onChange={() => setDocumentCategory('car')}
            className="sr-only"
          />
          <div className="flex flex-col items-center">
            <svg className="w-8 h-8 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
            </svg>
            <span className="font-medium">Car (سيارة)</span>
            <span className="text-xs text-gray-500 mt-1">Vehicle documents & licenses</span>
          </div>
        </label>
      </div>
    </div>
  );
};

export default DocumentCategorySelector;
